import { jsx as _jsx } from "react/jsx-runtime";
import WizardContainer from '../../containers/Wizard/WizardContainer';
import UIModalDialog from 'UIComponents/dialog/UIModalDialog';
import UIFullScreen from 'UIComponents/dialog/UIFullScreen';

const WizardPage = () => {
  // Use <UIModal> below if we decide to reintroduce modal animation
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIFullScreen, {
      children: /*#__PURE__*/_jsx(UIModalDialog, {
        "data-test-id": "wizard-modal",
        use: 'fullscreen',
        children: /*#__PURE__*/_jsx(WizardContainer, {})
      })
    })
  });
};

export default WizardPage;